module.exports = __webpack_public_path__ + "static/media/north-korea.e73ae351.svg";